import React from 'react';

import {Typography} from 'views/components';
import {Translate} from 'views/module';

const Title = (props) => {
  return (
    <Typography
      sx={{
        fontWeight: 'bold',
      }}
    >
      <Translate
        expression='loomLead.LoomLeadDetail.CareviewSettings.Types.MultipleChoice.Title'
      />
    </Typography>
  );
};

export default React.memo(Title);
